/**
 * Utility function to redirect with search parameters
 * @param {function} navigate - React Router's navigate function
 * @param {URLSearchParams} searchParams - Current search parameters
 * @param {string} path - Target path to navigate to
 * @param {string[]} [includeParams] - Optional array of parameter names to include (includes all if not specified)
 */
export const redirectWithSearchParams = (navigate, searchParams, path, includeParams) => {
    let queryString;
    
    if (includeParams && includeParams.length > 0) {
        const filteredParams = new URLSearchParams();
        
        includeParams.forEach(param => {
            const value = searchParams.get(param);
            if (value) {
                filteredParams.set(param, value);
            }
        });
        
        queryString = filteredParams.toString();
    } else {
        queryString = searchParams.toString();
    }

    navigate(queryString ? `${path}?${queryString}` : path);
};
